import { Controller, useFormContext } from "react-hook-form";
import {
    Autocomplete,
    AutocompleteItem,
    AutocompleteSection,
} from "@heroui/react";

function SectionedAutoCompleteInput({
    name,
    label,
    groups,
    labelPlacement,
    placeholder,
    required,
    size,
    onAutosave,
}: {
    name: string;
    label: string;
    groups: {
        value: string | number;
        label: string;
        options: {
            label: string;
            value: string | number;
        }[];
    }[];
    labelPlacement?: "inside" | "outside";
    placeholder?: string;
    required?: boolean;
    size?: "sm" | "md" | "lg";
    onAutosave?: () => void;
}) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onBlur, onChange, value },
                fieldState: { error, invalid },
            }) => (
                <Autocomplete
                    onSelectionChange={(e) => {
                        onChange(e);
                        if (onAutosave) onAutosave();
                    }}
                    onBlur={onBlur}
                    name={name}
                    isInvalid={invalid}
                    errorMessage={error?.message}
                    label={label}
                    labelPlacement={labelPlacement}
                    aria-label="Select"
                    selectedKey={value}
                    placeholder={placeholder}
                    disabledKeys={["no-options"]}
                    isRequired={required}
                    size={size}
                >
                    {groups.map((group, groupIndex) => (
                        <AutocompleteSection
                            key={`${group.label}-${groupIndex}`}
                            title={group.label}
                            className="font-bold"
                        >
                            {group.options.map((option) => (
                                <AutocompleteItem key={option.value}>
                                    {option.label}
                                </AutocompleteItem>
                            ))}
                        </AutocompleteSection>
                    ))}
                </Autocomplete>
            )}
        />
    );
}

export default SectionedAutoCompleteInput;
